import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/styles';
import MenuRoundedIcon from '@material-ui/icons/MenuRounded';
import { secondary1000 } from 'themes/colors';

const image = `${process.env.PUBLIC_URL}/img/pr-volt-white.png`;

const styles = theme => ({
  root: {
    color: theme.palette.secondary['0'],
    height: '3.5rem',
    cursor: 'pointer',
  },
  topbar: {
    width: '100%',
    position: 'fixed',
    top: '0',
    zIndex: '101',
    boxShadow: theme.shadows[0],
    backgroundColor: secondary1000,
  },
  topbar__wrapper: {
    position: 'relative',
    display: 'flex',
    height: '3.5rem',
  },
  topbar__right: {
    position: 'absolute',
    right: '0',
    display: 'flex',
    height: '100%',
    marginRight: '1.5rem',
  },
  topbar__left: {
    position: 'absolute',
    left: '0',
    display: 'flex',
    height: '100%',
    width: '50%',
  },
  topbar__logo: {
    width: '7rem',
    height: '2.125rem',
    margin: 'auto 0',
    marginLeft: '1.25rem',
    backgroundRepeat: 'no-repeat',
    backgroundPositionY: 'center',
    backgroundPositionX: 'left',
    backgroundSize: 'contain',
    backgroundImage: `url(${image})`,
  },
});

const Topbar = (props) => {
  const { classes, changeSidebarVisibility } = props;
  return (
    <div className={classes.topbar}>
      <div className={classes.topbar__wrapper}>
        <div className={classes.topbar__left}>
          <Link className={classes.topbar__logo} to="/" />
        </div>
        <div className={classes.topbar__right}>
          <MenuRoundedIcon classes={{ root: classes.root }} onClick={changeSidebarVisibility} />
        </div>
      </div>
    </div>
  );
};

Topbar.propTypes = {
  changeSidebarVisibility: PropTypes.func.isRequired,
  classes: PropTypes.element.isRequired,
};

export default withStyles(styles)(Topbar);
